import { useNavigate } from 'react-router-dom';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import DynamicButton from '../common/DynamicButton';
import { ReactComponent as SuccessIcon } from '../../assets/image/banner-success-24.svg';
import { ReactComponent as ErrorIcon } from '../../assets/image/banner-error-24.svg';

interface SuccessErrorModalProps {
  msg: string;
  success: boolean;
  setIsSuccessErrorModalOpen: (val: boolean) => void;
}

export const SuccessErrorModal = ({
  msg,
  success,
  setIsSuccessErrorModalOpen,
}: SuccessErrorModalProps) => {
  const navigate = useNavigate();

  return (
    <section
      className="topic-languages-modal-section flex column gap-8 align-center"
      style={{ padding: '20px' }}
    >
      <div className="upper">
        <CloseOutlinedIcon
          onClick={() => setIsSuccessErrorModalOpen(false)}
          style={{ cursor: 'pointer' }}
        />
      </div>
      <div className="content flex column gap-24 align-center justify-center">
        <span style={{ height: '72px', width: '72px' }}>
          {success ? (
            <SuccessIcon style={{ height: '100%', width: '100%' }} />
          ) : (
            <ErrorIcon style={{ height: '100%', width: '100%' }} />
          )}
        </span>
        <p className="h6-headline" style={{ margin: '0' }}>
          {msg}
        </p>
      </div>

      <div style={{ padding: '38px 0' }}>
        <DynamicButton
          type="tertiary"
          size="large"
          onClick={() => {
            navigate('/topics');
          }}
        >
          View all topics
        </DynamicButton>
      </div>
    </section>
  );
};
